import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant'
import Loading from 'vant'
import 'vant/lib/index.css'
import '../static/fonts/iconfont.css'
import less from 'less'
import store from './store'
import './utils/rem'
import i18n from './i18/i18.js'
import '@vant/touch-emulator'
import VueClipBoard from 'vue-clipboard2'
import {
  VueMasonryPlugin
} from 'vue-masonry'
import {
  DropdownMenu,
  DropdownItem
} from 'vant'
import {
  List
} from 'vant'
import {
  Lazyload
} from 'vant';

// h5跳小程序(测试)
import wx from 'weixin-js-sdk'
Vue.prototype.$wx = wx
Vue.config.ignoredElements = ['wx-open-launch-weapp']

// import './assets/jweixin-1.6.0'

Vue.use(Lazyload);
Vue.use(List)
Vue.use(DropdownMenu)
// import './assets/aliyun-oss-sdk-6.17.1.min'
// import './assets/aliyun-upload-sdk-1.5.3.min'
// import './assets/es6-promise.min'
// 防止多次点击
import preventReClick from './utils/prevent'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import request from './utils/request'
Vue.use(VueAwesomeSwiper)

Vue.mixin({
  beforeRouteLeave: function (to, from, next) {
    // 去的不是worksDetails页，不需要缓存
    if (to.name != 'worksDetails') {
      this.$route.meta.keepAlive = false
      next()
    }
    // 如果去的是活动详情页面， 那么开启活动详情页面的缓存状态  关闭当前页面的缓存
    if (to.name == 'Works' || to.name == 'ActivityDetails' || to.name == 'awardWorks') {
      this.$route.meta.keepAlive = false
      to.meta.keepAlive = true
      next()
    }
    // 用来重置滚动条
    if (from.name == 'Activity' && to.name == 'Works') {
      to.meta.keepAlive = false
      next()
    }
    // console.log(to);

    next()



  }
})




var str = sessionStorage.getItem('lang')
if (!str) {
  var Browser_Agent = navigator.userAgent
  // 浏览器为IE的情况
  if (Browser_Agent.indexOf(' MSIE ') != -1) {
    var a = navigator.browserLanguage
    if (a == 'zh-cn') {
      sessionStorage.setItem('lang', 'zhcn')
      sessionStorage.setItem('bl', false)
    } else {
      // 英文网站
      sessionStorage.setItem('lang', 'en')
      sessionStorage.setItem('bl', true)
    }
  }
  // 浏览器非IE的情况
  else {
    var b = navigator.language
    if (b == 'zh-CN') {
      sessionStorage.setItem('lang', 'zhcn')
      sessionStorage.setItem('bl', false)
    } else {
      // 英文网站
      sessionStorage.setItem('lang', 'en')
      sessionStorage.setItem('bl', true)
    }
  }
}


//Vue.use(Viewer) 默认配置写法
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
})
Vue.config.productionTip = false

Vue.use(preventReClick)
Vue.use(Vant)
Vue.use(less)
Vue.use(Loading)
// 复制内容至剪切板
Vue.use(VueClipBoard)
// 图片瀑布流
Vue.use(VueMasonryPlugin)
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
